// // src/context/ServiceContext.tsx
// import React, { createContext, useContext, useState } from "react";

// interface ServiceContextType {
//   serviceId: number | null;
//   setServiceId: (id: number | null) => void;
// }

// const ServiceContext = createContext<ServiceContextType>({
//   serviceId: null,
//   setServiceId: () => {},
// });

// export const ServiceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [serviceId, setServiceId] = useState<number | null>(null);

//   return (
//     <ServiceContext.Provider value={{ serviceId, setServiceId }}>
//       {children}
//     </ServiceContext.Provider>
//   );
// };

// export const useServiceContext = () => useContext(ServiceContext);

// src/context/ServiceContext.tsx

import React, { createContext, useContext, useState } from "react";

interface PaymentConfig {
  partial_payments_allowed?: boolean;
  // future:
  // min_partial_amount?: number;
  // min_partial_percentage?: number;
}

interface ServiceConfig {
  payments?: PaymentConfig;
  // extend later safely
}

interface ServiceContextType {
  serviceId: number | null;
  setServiceId: (id: number | null) => void;

  serviceConfig: any;
  setServiceConfig: (config: any) => void;
}

const ServiceContext = createContext<ServiceContextType>({
  serviceId: null,
  setServiceId: () => {},

  serviceConfig: {},
  setServiceConfig: () => {},
});

export const ServiceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [serviceId, setServiceId] = useState<number | null>(null);
  const [serviceConfig, setServiceConfig] = useState<any>({});

  return (
    <ServiceContext.Provider
      value={{ serviceId, setServiceId, serviceConfig, setServiceConfig }}
    >
      {children}
    </ServiceContext.Provider>
  );
};

export const useServiceContext = () => useContext(ServiceContext);